enum ReturnStatusEnum {
    none, regularWearTear, lost, damaged, replacement, change
}

export default ReturnStatusEnum;